import PropTypes from 'prop-types';

const ActionUserSettingsButtonPropType = {
  handleRenderComponent: PropTypes.func,
};

export default ActionUserSettingsButtonPropType;
